import type { PropertyExecutiveSummaryButtonGroupProps } from '../types/components'

export function PropertyExecutiveSummaryButtonGroup({
  name,
  value,
  options,
  disabled,
  onChange,
}: PropertyExecutiveSummaryButtonGroupProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const isSelected = String(value) === String(opt.value)
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            aria-pressed={isSelected}
            data-testid={`property-executive-summary-${name}-${opt.value}`}
            onClick={() => !disabled && onChange(name, opt.value)}
            className={`inline-flex min-h-[40px] min-w-[72px] items-center justify-center rounded-md border px-[22px] py-2 text-sm font-semibold transition-colors sm:min-w-[72px] ${
              disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
            } ${
              isSelected
                ? 'border-[rgb(21_151_255)] bg-[rgb(21_151_255)] text-white shadow-[0_1px_3px_rgba(21,151,255,0.35)]'
                : 'border-[#cbd5e1] bg-white text-[#334155] hover:border-[#94a3b8] hover:bg-[#f1f5f9]'
            }`}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
